import { timeIn } from '@shh/shared';
import { useEffect, useState } from 'react';

/** Wall-clock "HH:MM" in the household time zone, updated every 20 seconds. */
export function useClock(timeZone: string): string {
  const [now, setNow] = useState(() => timeIn(timeZone));
  useEffect(() => {
    const t = window.setInterval(() => setNow(timeIn(timeZone)), 20_000);
    setNow(timeIn(timeZone));
    return () => window.clearInterval(t);
  }, [timeZone]);
  return now;
}
